// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Enums
import { ReportBuilderModuleMenuSubTab } from 'NewAngular/enums/report-builder-tabs.enum';
// NgRx actions
import { setActiveTab } from './active-tab.action';
export const active_sub_tab = createReducer(ReportBuilderModuleMenuSubTab.MODULES, on(setActiveTab, (state, action) => {
    return action.sub_tab;
}));
